import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
//import { NgSpinKitModule } from 'ng-spin-kit';
import { ModalModule } from 'ngx-bootstrap/modal';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { ClipboardModule } from 'ngx-clipboard';
import { ApplicationParameterComponent } from './application-parameter/application-parameter.component';
import { CustomerAccountParams } from './data-service/customer-account-params';
import { CustomerCompanyParams } from './data-service/customer-company-params';
import { CustomerUserParams } from './data-service/customer-user-params';
import { NedermanCompanyParams } from './data-service/nederman-company-params';
import { NedermanUserParams } from './data-service/nederman-user-params';
import { ErrorComponent } from './error/error.component';
import { PermissionDirective } from './permission/permission.directive';
import { SpinnerComponent } from './spinner/spinner.component';
import { SuccessComponent } from './success/success.component';
import {DialogComponent} from './dialog/dialog.component';
import {DialogHeaderDirective} from './dialog/dialog-header.directive';
import {DialogContentDirective} from './dialog/dialog-content.directive';
import {DialogFooterDirective} from './dialog/dialog-footer.directive';

@NgModule({
  imports: [
    CommonModule,
    ModalModule,
    BsDatepickerModule,
    //NgSpinKitModule,
    ReactiveFormsModule,
    ClipboardModule,
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ModalModule,
    BsDatepickerModule,
    //NgSpinKitModule,
    SpinnerComponent,
    ErrorComponent,
    SuccessComponent,
    ApplicationParameterComponent,
    ClipboardModule,
    PermissionDirective,
    DialogComponent,
    DialogHeaderDirective,
    DialogContentDirective,
    DialogFooterDirective,
  ],
  declarations: [
    DialogComponent,
    DialogHeaderDirective,
    DialogContentDirective,
    DialogFooterDirective,
    SpinnerComponent,
    ErrorComponent,
    SuccessComponent,
    ApplicationParameterComponent,
    PermissionDirective,
  ],
  providers: [
    NedermanCompanyParams,
    NedermanUserParams,
    CustomerCompanyParams,
    CustomerUserParams,
    CustomerAccountParams
  ]
})
export class SharedModule { }
